import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "device_done",
  "use": "device_done-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"device_done\"><path d=\"M14 8A6 6 0 1 1 2 8a6 6 0 0 1 12 0zm-1.5 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0zm-7.507.354a.75.75 0 0 1 1.06-1.061l1.24 1.239 2.653-2.653a.75.75 0 0 1 1.06 1.06l-3.181 3.182a.748.748 0 0 1-.537.22.747.747 0 0 1-.527-.22L4.993 8.354z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol